<template>
  <div class="tiket-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="tiket-card elevation-0">
          <div class="tiket-toolbar">
            <div class="tiket-toolbar__left">
              <div class="tiket-toolbar__icon">
                <v-icon>mdi-ticket-outline</v-icon>
              </div>
              <div>
                <div class="tiket-toolbar__title">
                  {{ isAdmin ? 'Tiket Support' : 'Open Ticket' }}
                </div>
                <div class="tiket-toolbar__sub">
                  Konfirmasi pembayaran atau pengaduan masalah ·
                  {{ records.length || 0 }} tiket
                </div>
              </div>
            </div>

            <div class="tiket-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari subjek / kategori..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="tiket-search"
                clearable
              ></v-text-field>

              <v-btn
                icon
                class="tiket-icon-btn"
                :loading="loading"
                @click="fetchRecords"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-btn class="tiket-btn-primary" @click="openForm">
                <v-icon left small>mdi-plus</v-icon>
                Buka Tiket
              </v-btn>
            </div>
          </div>

          <v-data-table
            :headers="headers"
            :items="records"
            item-key="id"
            :items-per-page="20"
            class="tiket-table"
            :loading="loading"
            loading-text="Memuat tiket..."
            :search="search"
            hide-default-footer
          >
            <v-progress-linear
              slot="progress"
              color="#1f7a57"
              height="2"
              indeterminate
            ></v-progress-linear>

            <template v-slot:item.category_label="{ item }">
              <span
                class="tiket-cat"
                :class="
                  item.category === 'payment'
                    ? 'tiket-cat--pay'
                    : 'tiket-cat--complaint'
                "
              >
                {{ item.category_label }}
              </span>
            </template>

            <template v-slot:item.status="{ item }">
              <span
                class="tiket-status"
                :class="'tiket-status--' + item.status"
              >
                {{ item.status_label }}
              </span>
            </template>

            <template v-slot:item.attachment="{ item }">
              <v-btn
                v-if="item.attachment_url"
                icon
                x-small
                color="#1f7a57"
                :href="item.attachment_url"
                target="_blank"
              >
                <v-icon small>mdi-paperclip</v-icon>
              </v-btn>
              <span v-else class="tiket-muted">—</span>
            </template>

            <template v-slot:item.id="{ item }">
              <v-menu bottom left transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-bind="attrs" v-on="on">
                    <v-icon small color="#1f7a57">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="openDetail(item)">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-eye-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Detail</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="isAdmin && item.status !== 'progress'"
                    @click="setStatus(item, 'progress')"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon small color="blue">mdi-progress-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Proses</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="isAdmin && item.status !== 'done'"
                    @click="setStatus(item, 'done')"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon small color="green">mdi-check-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Selesai</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="isAdmin && item.status !== 'open'"
                    @click="setStatus(item, 'open')"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon small color="orange">mdi-restore</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Buka ulang</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="confirmDelete(item)">
                    <v-list-item-icon class="mr-2">
                      <v-icon small color="red">mdi-delete-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Hapus</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Form buka tiket -->
    <v-dialog
      v-model="form.open"
      persistent
      :max-width="device.desktop ? '560px' : '100%'"
      transition="dialog-bottom-transition"
    >
      <v-card class="tiket-dialog">
        <div class="tiket-dialog__head">
          <div class="tiket-dialog__title">
            <v-icon left color="#1f7a57">mdi-ticket-confirmation-outline</v-icon>
            Buka Tiket Baru
          </div>
          <v-btn icon small @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="tiket-dialog__body">
          <div class="tiket-field-label">Kategori</div>
          <v-select
            v-model="record.category"
            :items="categories"
            item-text="text"
            item-value="value"
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            class="mb-4"
          ></v-select>

          <div class="tiket-field-label">Subjek</div>
          <v-text-field
            v-model="record.subject"
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            placeholder="Ringkas perihal tiket"
            class="mb-4"
          ></v-text-field>

          <div class="tiket-field-label">Keterangan</div>
          <v-textarea
            v-model="record.content"
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            rows="4"
            placeholder="Jelaskan pembayaran / permasalahan Anda"
            class="mb-4"
          ></v-textarea>

          <div class="tiket-field-label">
            Bukti lampiran
            <span class="tiket-muted">
              (opsional — wajib disarankan untuk konfirmasi pembayaran)
            </span>
          </div>
          <div v-if="record.attachment_url" class="tiket-attach">
            <img
              v-if="isImageAttach(record.attachment)"
              :src="record.attachment_url"
              alt="bukti"
            />
            <a
              v-else
              :href="record.attachment_url"
              target="_blank"
              class="tiket-attach-file"
            >
              <v-icon left color="#1f7a57">mdi-file-document-outline</v-icon>
              {{ record.attachment }}
            </a>
            <v-btn icon x-small class="tiket-attach__clear" @click="clearAttach">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-btn
            outlined
            class="tiket-btn-upload"
            :loading="uploading"
            @click="uploadAttach"
          >
            <v-icon left small>mdi-upload</v-icon>
            {{ record.attachment ? 'Ganti Bukti' : 'Unggah Bukti' }}
          </v-btn>
        </div>

        <div class="tiket-dialog__actions">
          <v-btn text class="tiket-btn-ghost" @click="closeForm">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="tiket-btn-primary"
            :loading="saving"
            :disabled="saving"
            @click="submitTicket"
          >
            <v-icon left small>mdi-send-outline</v-icon>
            Kirim Tiket
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Detail -->
    <v-dialog
      v-model="detail.open"
      :max-width="device.desktop ? '560px' : '100%'"
      transition="dialog-bottom-transition"
    >
      <v-card v-if="detail.item" class="tiket-dialog">
        <div class="tiket-dialog__head">
          <div class="tiket-dialog__title">
            <v-icon left color="#1f7a57">mdi-text-box-outline</v-icon>
            Detail Tiket
          </div>
          <v-btn icon small @click="detail.open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="tiket-dialog__body">
          <div class="tiket-meta">
            <span
              class="tiket-cat"
              :class="
                detail.item.category === 'payment'
                  ? 'tiket-cat--pay'
                  : 'tiket-cat--complaint'
              "
            >
              {{ detail.item.category_label }}
            </span>
            <span
              class="tiket-status"
              :class="'tiket-status--' + detail.item.status"
            >
              {{ detail.item.status_label }}
            </span>
          </div>
          <div class="tiket-detail-subject">{{ detail.item.subject }}</div>
          <div class="tiket-detail-content">{{ detail.item.content }}</div>
          <div v-if="isAdmin && detail.item.user_name" class="tiket-detail-user">
            Pengirim: {{ detail.item.user_name }}
            <span v-if="detail.item.user_email">({{ detail.item.user_email }})</span>
          </div>
          <div class="tiket-muted mt-2">{{ detail.item.tanggal }}</div>
          <div v-if="detail.item.attachment_url" class="tiket-attach mt-4">
            <a :href="detail.item.attachment_url" target="_blank">
              <img
                v-if="isImageAttach(detail.item.attachment)"
                :src="detail.item.attachment_url"
                alt="bukti"
              />
              <span v-else class="tiket-attach-file">
                <v-icon left color="#1f7a57">mdi-file-document-outline</v-icon>
                Lihat lampiran
              </span>
            </a>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UtilityTiket",
  data: () => ({
    search: "",
    loading: false,
    saving: false,
    uploading: false,
    records: [],
    form: { open: false },
    detail: { open: false, item: null },
    record: {
      category: "payment",
      subject: "",
      content: "",
      attachment: null,
      attachment_url: null,
    },
    categories: [
      { value: "payment", text: "Konfirmasi Pembayaran" },
      { value: "complaint", text: "Pengaduan Masalah" },
    ],
  }),
  computed: {
    ...mapState(["theme", "http", "device", "snackbar", "user"]),
    isAdmin() {
      return this.user && this.user.authent === "superadmin";
    },
    headers() {
      const cols = [
        { text: "Tanggal", value: "tanggal", width: "140px" },
        { text: "Kategori", value: "category_label", width: "180px" },
        { text: "Subjek", value: "subject" },
        { text: "Status", value: "status", width: "120px" },
        { text: "Bukti", value: "attachment", width: "70px", sortable: false },
      ];
      if (this.isAdmin) {
        cols.splice(2, 0, {
          text: "Pengirim",
          value: "user_name",
          width: "160px",
        });
      }
      cols.push({
        text: "",
        value: "id",
        sortable: false,
        width: "48px",
        align: "end",
      });
      return cols;
    },
  },
  mounted() {
    this.fetchRecords();
  },
  methods: {
    ...mapActions(["assignFileBrowse"]),
    isImageAttach(name) {
      return /\.(jpe?g|png|webp)$/i.test(name || "");
    },
    async fetchRecords() {
      this.loading = true;
      try {
        const { data } = await this.http.get("api/utility/tickets");
        this.records = Array.isArray(data) ? data : [];
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal memuat tiket";
        this.snackbar.state = true;
      } finally {
        this.loading = false;
      }
    },
    openForm() {
      this.record = {
        category: "payment",
        subject: "",
        content: "",
        attachment: null,
        attachment_url: null,
      };
      this.form.open = true;
    },
    closeForm() {
      this.form.open = false;
    },
    clearAttach() {
      this.record.attachment = null;
      this.record.attachment_url = null;
    },
    uploadAttach() {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png", ".webp", ".pdf"],
        maxSize: 5000000,
        query: { doctype: "tickets" },
        callback: (response) => {
          this.uploading = false;
          if (!response || !response.name) {
            this.snackbar.color = "red";
            this.snackbar.text = "Gagal mengunggah bukti";
            this.snackbar.state = true;
            return;
          }
          this.record.attachment = response.name;
          this.record.attachment_url = response.path;
        },
      });
      this.uploading = true;
      setTimeout(() => {
        this.uploading = false;
      }, 8000);
    },
    async submitTicket() {
      if (!this.record.subject || this.record.subject.trim().length < 3) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Subjek minimal 3 karakter";
        this.snackbar.state = true;
        return;
      }
      if (!this.record.content || this.record.content.trim().length < 5) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Keterangan minimal 5 karakter";
        this.snackbar.state = true;
        return;
      }
      if (this.record.category === "payment" && !this.record.attachment) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Unggah bukti pembayaran terlebih dahulu";
        this.snackbar.state = true;
        return;
      }

      this.saving = true;
      try {
        const { data } = await this.http.post("api/utility/tickets", {
          category: this.record.category,
          subject: this.record.subject.trim(),
          content: this.record.content.trim(),
          attachment: this.record.attachment || null,
        });
        if (data && data.success === false) {
          this.snackbar.color = "red";
          this.snackbar.text = data.message || "Gagal mengirim tiket";
          this.snackbar.state = true;
          return;
        }
        this.snackbar.color = "green";
        this.snackbar.text = "Tiket berhasil dikirim";
        this.snackbar.state = true;
        this.closeForm();
        this.fetchRecords();
      } catch (e) {
        const msg =
          (e.response &&
            e.response.data &&
            (e.response.data.message ||
              (e.response.data.errors &&
                Object.values(e.response.data.errors)[0]))) ||
          "Gagal mengirim tiket";
        this.snackbar.color = "red";
        this.snackbar.text = Array.isArray(msg) ? msg[0] : msg;
        this.snackbar.state = true;
      } finally {
        this.saving = false;
      }
    },
    openDetail(item) {
      this.detail.item = item;
      this.detail.open = true;
    },
    async setStatus(item, status) {
      try {
        const { data } = await this.http.post(
          `api/utility/tickets/${item.id}/status`,
          { status }
        );
        if (data && data.success === false) {
          this.snackbar.color = "red";
          this.snackbar.text = data.message || "Gagal ubah status";
          this.snackbar.state = true;
          return;
        }
        this.snackbar.color = "green";
        this.snackbar.text = "Status tiket diperbarui";
        this.snackbar.state = true;
        this.fetchRecords();
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal ubah status";
        this.snackbar.state = true;
      }
    },
    async confirmDelete(item) {
      const ok = await this.$confirm({
        title: "Hapus Tiket",
        text: `Hapus tiket “${item.subject}”?`,
        confirmText: "Ya, Hapus",
        cancelText: "Batal",
        danger: true,
      });
      if (!ok) return;
      try {
        await this.http.delete(`api/utility/tickets/${item.id}`);
        this.snackbar.color = "green";
        this.snackbar.text = "Tiket dihapus";
        this.snackbar.state = true;
        this.fetchRecords();
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal menghapus tiket";
        this.snackbar.state = true;
      }
    },
  },
};
</script>

<style scoped>
.tiket-page {
  background: transparent;
}

.tiket-card {
  border: 1px solid rgba(15, 74, 54, 0.12);
  border-radius: 14px !important;
  overflow: hidden;
  background: #fff;
}

.tiket-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(15, 74, 54, 0.08);
  background: linear-gradient(180deg, #f4faf7 0%, #fff 100%);
}

.tiket-toolbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tiket-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1f7a57;
  color: #fff;
}

.tiket-toolbar__icon .v-icon {
  color: #fff !important;
}

.tiket-toolbar__title {
  font-weight: 700;
  color: #0d4a36;
  line-height: 1.2;
}

.tiket-toolbar__sub {
  font-size: 12px;
  color: #5f7a70;
}

.tiket-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tiket-search {
  max-width: 260px;
  min-width: 180px;
}

.tiket-icon-btn {
  border: 1px solid rgba(15, 74, 54, 0.15) !important;
}

.tiket-btn-primary {
  background: #1f7a57 !important;
  color: #fff !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600;
  box-shadow: none !important;
}

.tiket-btn-ghost {
  text-transform: none !important;
  color: #5f7a70 !important;
}

.tiket-btn-upload {
  border-color: #1f7a57 !important;
  color: #1f7a57 !important;
  text-transform: none !important;
}

.tiket-table >>> th {
  background: #f7fbf9 !important;
  color: #0d4a36 !important;
  font-weight: 600 !important;
}

.tiket-cat {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
}

.tiket-cat--pay {
  background: #e8f5ef;
  color: #1f7a57;
}

.tiket-cat--complaint {
  background: #fff3e8;
  color: #c56a1a;
}

.tiket-status {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
}

.tiket-status--open {
  background: #fff4e5;
  color: #b86e00;
}

.tiket-status--progress {
  background: #e8f0fe;
  color: #1a56c5;
}

.tiket-status--done {
  background: #e8f5ef;
  color: #1f7a57;
}

.tiket-muted {
  color: #8aa097;
  font-size: 12px;
}

.tiket-dialog {
  border-radius: 14px !important;
}

.tiket-dialog__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(15, 74, 54, 0.08);
  background: #f4faf7;
}

.tiket-dialog__title {
  font-weight: 700;
  color: #0d4a36;
  display: flex;
  align-items: center;
}

.tiket-dialog__body {
  padding: 16px 18px;
}

.tiket-dialog__actions {
  display: flex;
  align-items: center;
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(15, 74, 54, 0.08);
}

.tiket-field-label {
  font-size: 12px;
  font-weight: 600;
  color: #0d4a36;
  margin-bottom: 6px;
}

.tiket-attach {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(15, 74, 54, 0.12);
}

.tiket-attach img {
  display: block;
  max-width: 220px;
  max-height: 160px;
  object-fit: cover;
}

.tiket-attach__clear {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.9) !important;
}

.tiket-meta {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.tiket-detail-subject {
  font-weight: 700;
  color: #0d4a36;
  font-size: 16px;
  margin-bottom: 8px;
}

.tiket-detail-content {
  white-space: pre-wrap;
  color: #334943;
  line-height: 1.5;
}

.tiket-detail-user {
  margin-top: 12px;
  font-size: 13px;
  color: #5f7a70;
}

.tiket-attach-file {
  display: inline-flex;
  align-items: center;
  padding: 12px 14px;
  color: #0d4a36;
  text-decoration: none;
  font-size: 13px;
}

@media (max-width: 600px) {
  .tiket-search {
    max-width: 100%;
    width: 100%;
  }
  .tiket-toolbar__actions {
    width: 100%;
  }
}
</style>
